import pn from 'pnotify/lib/umd/PNotify';
import 'pnotify/lib/umd/PNotifyButtons';
import 'pnotify/lib/umd/PNotifyCallbacks';
import './style.scss';

const PNOTIFY_DEFAULT_SETTINGS = {
  icons: 'fontawesome5',
  // This is the code to show the buttons without hovering over the notification
  // modules: {
  //   Buttons: {
  //     closerHover: false,
  //     stickerHover: false,
  //   },
  // },
};

export const PNotify = pn;

export const pNotifyAlert = (settings) => {
  return pn.alert({ ...PNOTIFY_DEFAULT_SETTINGS, ...settings });
};
